import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import {
  Grid, Modal, Icon, Table, Header, Divider,
} from 'semantic-ui-react';
import Heading from '../../ProfileModal/Heading';

const ProjectList = ({ matchedQueries }) => {
  const queries = matchedQueries.map((m) => m.query);
  const matches = Object.values(
    matchedQueries.reduce((acc, { query, items }) => {
      items.forEach(({ id, title }) => {
        if (!acc[id]) {
          acc[id] = { id, title, queries: [] };
        }
        acc[id].queries.push(query);
      });
      return acc;
    }, {}),
  );
  return (
    <Grid.Column>
      <Header>
        Expert&apos;s project matches:
        <Header.Subheader>
          {`A project matches a search term when 1. the expert has completed the project
            and 2. search term is a project keyword or expert has mentioned the search term
            (e.g. in qualification questions or in the interview transcript)
          `}
        </Header.Subheader>
      </Header>
      <Table striped celled unstackable>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell />
            {queries.map((query) => (
              <Table.HeaderCell key={query} textAlign="center">{query}</Table.HeaderCell>
            ))}
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {matches.map((m) => (
            <Table.Row key={m.id}>
              <Table.Cell>
                <NavLink to={`/projects/${m.id}`} target="_blank">{m.title}</NavLink>
              </Table.Cell>
              {queries.map((query) => (
                <Table.Cell key={query} textAlign="center">
                  {m.queries.includes(query) && <Icon name="check" color="green" />}
                </Table.Cell>
              ))}
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </Grid.Column>
  );
};

const MatchedProjects = ({ expert, searchData }) => {
  const [open, setOpen] = useState(false);
  if (!searchData) return <div />;
  const { matchedQueries } = searchData;
  if (matchedQueries.length === 0) {
    return <div />;
  }
  return (
    <Grid>
      <Grid.Row columns={2}>
        <Grid.Column width={14}>
          <p className="project-match-section black">
            <strong>{'Projects: '}</strong>
            {matchedQueries.map((m) => `${m.query} (${m.items.length})`).join(', ')}
          </p>
        </Grid.Column>
        <Grid.Column width={2} textAlign="center" verticalAlign="middle">
          <Modal
            open={open}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            trigger={(<Icon name="angle right" size="large" color="black" link />)}
            closeIcon
          >
            <Modal.Content>
              <Grid>
                <Grid.Row columns={2} className="heading">
                  <Heading expert={expert} />
                </Grid.Row>
                <Divider />
                <Grid.Row>
                  <ProjectList matchedQueries={matchedQueries} />
                </Grid.Row>
              </Grid>
            </Modal.Content>
          </Modal>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export default MatchedProjects;
